<template>
    <div>
        <CRow>
            <CCol>
                <div style="width:100%; height: 75vh;">
                    <ejs-grid ref='gridsc' :dataSource='spotConfigData' :allowFiltering='true' :allowPaging='true' :allowResizing='true'
                              :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :editSettings='editSettings'
                              :pageSettings='pageSettings' :filterSettings='filterOptions' :toolbarClick='toolbarClick' :actionBegin='actionBegin' :actionFailure="actionFailure" :actionComplete="actionComplete"
                              :allowExcelExport='true' :excelExportComplete='excelExportComplete' width="100%" height="100%">
                        <e-columns>
                            <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='ric' headerText='Identifier' :validationRules="requiredRules" width=180></e-column>
                            <e-column field='stateId' headerText='Country' :visible="false" :validationRules="requiredRules" width=120 :edit='stateParams' foreignKeyField='stateId' foreignKeyValue='stateName' :dataSource='states' editType='dropdownedit'></e-column>
                            <e-column field='stateName' headerText='Country' textAlign='Left' width=180 type="string"></e-column>
                            <e-column field='priceAreaId' headerText='Price Area' width=120 :visible="false" foreignKeyField='id' foreignKeyValue='name' :edit='priceAreaParams' :dataSource='priceArea' editType='dropdownedit'></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' textAlign='Left' width=180 type="string"></e-column>
                            <e-column field='utilityTypeId' headerText='Commodity' :validationRules="requiredRules" width=180 :edit='utilitiesParams' foreignKeyField='utilityTypeId' foreignKeyValue='utilityTypeName' :dataSource='utilities' editType='dropdownedit'></e-column>
                            <e-column field='productId' headerText='Product' :validationRules="requiredRules" width=180 :edit='productParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='products' editType='dropdownedit'></e-column>
                            <e-column field='providerType'
                                      headerText='Provider Type'
                                      :validationRules="requiredRules"
                                      width=180
                                      :edit='providerTypeParams'
                                      foreignKeyField='id'
                                      foreignKeyValue='name'
                                      :dataSource='providerType'
                                      editType='dropdownedit'>
                            </e-column>
                            <e-column field='description' headerText='Description' width=180></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </CCol>
        </CRow>
    </div>
</template>
<script>

    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import axios from 'axios';
    import gridOptions from '../../../common/gridOptions'
    import SyncHelper from '../../../common/syncfusion'
    import store from '../../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);




    let dpStates, elStates, dpUtilities, elUtilities, dpProducts, elProducts, dpPriceArea, elPriceArea, providerTypeElem, providerTypeObj

    export default {
        name: 'SpotConfig',
        data() {
            return {
                store: store,
                spotConfigData: SyncHelper.getDataManager("spotConfig"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.SpotConfig.Update"],
                    allowAdding: store.state.permissions["Permissions.SpotConfig.Create"],
                    allowDeleting: store.state.permissions["Permissions.SpotConfig.Delete"],
                    mode: 'Dialog'
                },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 0,
                        format: "N"
                    }
                },
                requiredRules: { required: true },
                numericRules: { required: true, number: true },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                states: SyncHelper.getDataManager("utils/states"),
                priceArea: SyncHelper.getDataManager("utils/priceAreasWithoutStateName"),
                products: SyncHelper.getDataManager("utils/products"), utilities: SyncHelper.getDataManager("utils/utilities"),
                providerType: SyncHelper.getDataManager("utils/providerType"),

                stateParams: {
                    create: () => {
                        elStates = document.createElement('input');
                        return elStates;
                    },
                    read: () => {
                        return dpStates.value;
                    },
                    destroy: () => {
                        dpStates.destroy();
                    },
                    write: (args) => {
                        dpStates = new DropDownList({
                            dataSource: this.states,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Country',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                            change: (args) => {
                                dpPriceArea.enabled = true;
                                let tempQuery = new Query().where('stateId', 'equal', dpStates.value);
                                dpPriceArea.query = tempQuery;
                                dpPriceArea.text = null;
                                dpPriceArea.dataBind();
                                this.onStateChange(args);
                                //dpPriceArea.showPopup();
                              
                            }
                        });
                        dpStates.appendTo(elStates);
                    }
                },
                providerTypeParams: {
                    create: () => {
                        providerTypeElem = document.createElement('input');
                        return providerTypeElem;
                    },
                    read: () => {
                        return providerTypeObj.value;
                    },
                    destroy: () => {
                        providerTypeObj.destroy();
                    },
                    write: (args) => {
                        providerTypeObj = new DropDownList({
                            dataSource: this.providerType,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Provider Type',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                        });
                        providerTypeObj.appendTo(providerTypeElem);
                    }
                },
                utilitiesParams: {
                    create: () => {
                        elUtilities = document.createElement('input');
                        return elUtilities;
                    },
                    read: () => {
                        return dpUtilities.value;
                    },
                    destroy: () => {
                        dpUtilities.destroy();
                    },
                    write: (args) => {
                        dpUtilities = new DropDownList({
                            dataSource: this.utilities,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Commodity',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            actionComplete: this.utilitiesActionComplete,
                            cssClass: 'required-input',
                            change: (args) => {
                                dpProducts.enabled = true;
                                let tempQuery = new Query().where('utilityTypeId', 'equal', dpUtilities.value);
                                dpProducts.query = tempQuery;
                                dpProducts.text = null;
                                dpProducts.dataBind();
                                this.onUtilityChange(args);
                            },
                        });
                        dpUtilities.appendTo(elUtilities);
                    }
                },
                priceAreaParams: {
                    create: () => {
                        elPriceArea = document.createElement('input');
                        return elPriceArea;
                    },
                    read: () => {
                        return dpPriceArea.value;
                    },
                    destroy: () => {
                        dpPriceArea.destroy();
                    },
                    write: (args) => {

                        dpPriceArea = new DropDownList({
                            dataSource: this.priceArea,
                            query: new Query().addParams("stateId", args.rowData.stateId),
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Price Area',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            actionComplete: this.priceAreaActionComplete,
                        });
                        if ((args.foreignKeyData && args.foreignKeyData[0])) {
                            let tempQuery = new Query().where('stateId', 'equal', dpStates.value);
                            dpPriceArea.query = tempQuery;
                        }
                        dpPriceArea.appendTo(elPriceArea);

                    }
                },
                productParams: {
                    create: () => {
                        elProducts = document.createElement('input');
                        return elProducts;
                    },
                    read: () => {
                        return dpProducts.value;
                    },
                    destroy: () => {
                        dpProducts.destroy();
                    },
                    write: (args) => {
                        dpProducts = new DropDownList({
                            dataSource: this.products,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Product',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                            enabled: ((args.foreignKeyData && args.foreignKeyData[0]) ? true : false)
                        });
                        if ((args.foreignKeyData && args.foreignKeyData[0])) {
                            let tempQuery = new Query().where('utilityTypeId', 'equal', dpUtilities.value);
                            dpProducts.query = tempQuery;
                        }
                        dpProducts.appendTo(elProducts);
                    }
                },
                filterOptions: gridOptions.filterSettings,
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });

            const spinners = document.querySelectorAll(".e-grid .e-spinner-pane:not(#mainSpinner)");
            spinners.forEach(spinner => {

                spinner.style.display = 'none';

            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "SpotConfiguration.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridsc.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args, this.$refs);
    
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.gridsc.getColumns().length; i++) {

                    }
                    this.$refs.gridsc.getColumns()[2].visible = true;
                    this.$refs.gridsc.getColumns()[3].visible = false;
                    this.$refs.gridsc.getColumns()[4].visible = true;
                    this.$refs.gridsc.getColumns()[5].visible = false;
                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));
                    this.$refs.gridsc.getColumns()[2].visible = false;
                    this.$refs.gridsc.getColumns()[3].visible = true;
                    this.$refs.gridsc.getColumns()[4].visible = false;
                    this.$refs.gridsc.getColumns()[5].visible = true;

                }

                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));


                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));

                }
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["ric"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                    
                }
                if (args.requestType === 'beginEdit') {
                    let ddRic = document.querySelector('[id^="grid"][id$="ric"]')
                    ddRic.ej2_instances[0].enabled = true; //interim solution for manually importing prices and using Montel keys
                    let ddPriceArea = document.querySelector('[id^="grid"][id$="priceAreaId"]')
                    ddPriceArea.ej2_instances[0].enabled = false;
                    let ddState = document.querySelector('[id^="grid"][id$="stateId"]')
                    ddState.ej2_instances[0].enabled = false;
                    let ddCommodity = document.querySelector('[id^="grid"][id$="utilityTypeId"]')
                    ddCommodity.ej2_instances[0].enabled = false;
                    let ddProduct = document.querySelector('[id^="grid"][id$="productId"]')
                    ddProduct.ej2_instances[0].enabled = false;
                    //setTimeout(function () {
                    //    let ddPriceArea = document.querySelector('[id^="grid"][id$="priceAreaId"]')
                    //    const itemCount = ddPriceArea.ej2_instances[0].listData ? ddPriceArea.ej2_instances[0].listData.length : 0;
                    //    if (itemCount == 0) {
                    //        ddPriceArea.ej2_instances[0].readonly = true;
                    //    }
                    //    else {
                    //        ddPriceArea.ej2_instances[0].readonly = false;
                    //    }
                    //}, 1000);
                }
                if (args.requestType == 'save') {
                    this.$refs.gridsc.refresh();

                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            onStateChange(args) {
                if (args.isInteracted) {
                    var errorMsg = document.getElementById('priceAreaId_Error');
                    let dpUtility = document.querySelector('[id^="grid"][id$="utilityTypeId"]').ej2_instances[0].text;
                    let ddPriceArea = document.querySelector('[id^="grid"][id$="priceAreaId"]')
                    let elementForm = document.querySelector('[id^="grid"][id$="EditForm"]')
                    if (dpUtility == "Gas") {
                        const formValidator = elementForm.ej2_instances[0];
                        if (args.itemData.stateName == "Denmark" || args.itemData.stateName == "Sweden" || args.itemData.stateName == "Norway" || args.itemData.stateName == "Finland") {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.remove('required-input');
                            setTimeout(function () {
                                //ddPriceArea.ej2_instances[0].hidePopup();
                                ddPriceArea.ej2_instances[0].readonly = true;
                                ddPriceArea.ej2_instances[0].value = null;
                                ddPriceArea.ej2_instances[0].text = null;
                                ddPriceArea.ej2_instances[0].enabled = false;
                                formValidator.addRules('priceAreaId', { required: false });
                            }, 300);

                            if (errorMsg != null) {
                                errorMsg.style = 'top: 230px; left: 100.5px; max-width: 282px; text-align: center; display: none';
                            }

                        }

                    } else {
                        const formValidator = elementForm.ej2_instances[0];
                        if (args.itemData.stateName == "Denmark" || args.itemData.stateName == "Sweden" || args.itemData.stateName == "Norway" || args.itemData.stateName == "Finland") {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.add('required-input');
                            setTimeout(function () {
                                //ddPriceArea.ej2_instances[0].showPopup();
                                ddPriceArea.ej2_instances[0].readonly = false;
                                ddPriceArea.ej2_instances[0].enabled = true;
                                formValidator.addRules('priceAreaId', { required: true });
                            }, 300);
                            if (errorMsg != null) {
                                errorMsg.style = 'top: 230px; left: 100.5px; max-width: 282px; text-align: center; display: block';
                            }
                        }
                        else {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.remove('required-input');
                            setTimeout(function () {
                                ddPriceArea.ej2_instances[0].readonly = true;
                                ddPriceArea.ej2_instances[0].value = null;
                                ddPriceArea.ej2_instances[0].text = null;
                                ddPriceArea.ej2_instances[0].enabled = false;
                                formValidator.addRules('priceAreaId', { required: false });
                            }, 300);
                        }


                    }


                }

            },
            onUtilityChange(args) {
                if (args.isInteracted) {
                    var errorMsg = document.getElementById('priceAreaId_Error');
                    let ddPriceArea = document.querySelector('[id^="grid"][id$="priceAreaId"]')
                    let elementForm = document.querySelector('[id^="grid"][id$="EditForm"]')
                    if (args.itemData.utilityTypeName == "Gas") {
                        const formValidator = elementForm.ej2_instances[0];
                        let dpState = document.querySelector('[id^="grid"][id$="stateId"]').ej2_instances[0].text;
                        if (dpState == "Denmark" || dpState == "Sweden" || dpState == "Norway" || dpState == "Finland") {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.remove('required-input');
                            parentDiv.classList.remove('e-error');
                            parentDiv.classList.add('e-disabled');
                            setTimeout(function () {
                                //ddPriceArea.ej2_instances[0].hidePopup();
                                ddPriceArea.ej2_instances[0].readonly = true;
                                ddPriceArea.ej2_instances[0].value = null;
                                ddPriceArea.ej2_instances[0].text = null;
                                ddPriceArea.ej2_instances[0].enabled = false;
                                formValidator.addRules('priceAreaId', { required: false });
                            }, 300);

                         
                            if (errorMsg != null) {
                                errorMsg.style = 'top: 230px; left: 100.5px; max-width: 282px; text-align: center; display: none';
                            }
                        }

                    } else {
                        const formValidator = elementForm.ej2_instances[0];
                        let dpState = document.querySelector('[id^="grid"][id$="stateId"]').ej2_instances[0].text;
                        if (dpState == "Denmark" || dpState == "Sweden" || dpState == "Norway" || dpState == "Finland") {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.add('required-input');
                            setTimeout(function () {
                                //ddPriceArea.ej2_instances[0].showPopup();
                                ddPriceArea.ej2_instances[0].readonly = false;
                                ddPriceArea.ej2_instances[0].enabled = true;
                                formValidator.addRules('priceAreaId', { required: true });
                            }, 300);
                            if (errorMsg != null) {
                                errorMsg.style = 'top: 230px; left: 100.5px; max-width: 282px; text-align: center; display: block';
                            }
                        }
                        else {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.remove('required-input');
                            parentDiv.classList.remove('e-error');
                            ddPriceArea.ej2_instances[0].readonly = true;
                            ddPriceArea.ej2_instances[0].value = null;
                            ddPriceArea.ej2_instances[0].text = null;
                            ddPriceArea.ej2_instances[0].enabled = false;
                            formValidator.addRules('priceAreaId', { required: false });
                        }

                    }
         
                }
     

            },
            utilitiesActionComplete(args) {
       
            },
            priceAreaActionComplete(args) {
                let ddPriceArea = document.querySelector('[id^="grid"][id$="priceAreaId"]')
                if (ddPriceArea) {
                    let parentDiv = ddPriceArea.closest('.e-input-group');
                    if (parentDiv) {
                        let elementForm = document.querySelector('[id^="grid"][id$="EditForm"]')
                        const formValidator = elementForm.ej2_instances[0];
                        if (args.result.length > 0) {
                          //  parentDiv.classList.add('required-input');
                            ddPriceArea.ej2_instances[0].readonly = false;
                            formValidator.addRules('priceAreaId', { required: true });
                        }
                        else {
                           // parentDiv.classList.remove('required-input');
                            setTimeout(function () {
                                ddPriceArea.ej2_instances[0].hidePopup();
                                ddPriceArea.ej2_instances[0].readonly = true;
                                formValidator.addRules('priceAreaId', { required: false });
                            }, 300);
                        }
                    }
                }
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>
